<template>
  <div class="row col-12">
    <!-- Contenedor de la imagen -->
    <div
      class="image-container"
      @click="!disabled ? selectItem() : ''"
    >
      <!-- Imagen del objetivo -->
      <q-img
        v-if="imgObjetivo"
        :src="imgObjetivo"
        :alt="datos.name"
        :class="['Imagen', disabled ? 'disabled' : '']"
      />
    </div>
    <!-- Contenedor de las Metas del objetivo seleccionado -->
    <div class="meta-container col-12" v-if="displayMetas">
      <div class="row">
        <!-- Título del listado de metas -->
        <div class="col-12 meta-title">
         <div class="meta q-pb-sm">
          <q-img
           :src="require(`@/assets/img/group-meta.svg`)"
           :alt="datos.imagen"
           height="30px"
           width="30px"
           contain
          />
         METAS
        </div>
        </div>
      </div>
      <!-- Listado de las metas -->
      <div
        class="row"
        v-for="(meta, index) in metas"
        v-bind:key="index"
      >
        <!-- Contenedor de una meta -->
        <div
          class="col-12 contenedor-meta"
          @click="selectMeta(meta)"
          :style="`background-color: ${datos.color};`"
        >
          <span class="txt-meta" style="color: #4c4c4c;">
            {{meta.name}}
          </span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QImg } from 'quasar';
import Resources from '@/components/shared/mixins/Resources.js';

export default {
  mixins: [Resources],
  components: {
    QImg
  },
  props: {
    datos: Object,
    ciudadIndice: Object,
    disabled: Boolean,
    displayMetas: Boolean
  },
  data () {
    return {
      imagen: this.datos.imagen,
      metas: this.ciudadIndice.metas
    };
  },
  computed: {
    imgObjetivo () {
      let res = this.searchResource(this.datos.file, 'imagen');
      return res ? res.url : this.getDefaultResource('imagen');
    }
  },
  methods: {
    selectItem () {
      this.$emit('selected', this.datos);
    },
    selectMeta (meta) {
      this.$eventHub.$emit('showIndicadoresMeta', meta);
    }
  }
};
</script>

<style lang="scss" scoped>
.image-container {
  padding: 0;
  width: 100%;
  :hover {
    cursor: pointer;
  }
}

.meta-container {
  .meta-title {
    display:flex;
    padding-top: 36px;
    padding-bottom: 16px;
  }
  .contenedor-meta {
    background-color: rgba(229, 36, 58, 0.37);
    border-radius: 8px;
    height: 72px;
    margin-bottom: 34px;
    padding: 15px 22px 20px 22px;
    .txt-meta {
      font-family: "DINPro";
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.2px;
      color: #4c4c4c;
    }
  }
}

.disabled {
  filter: grayscale(70%);
  opacity: 0.3;
}
.image-container{
&:hover {
  .q-img.overflow-hidden.Imagen:not(.disabled){
    height: calc(100% + 2%) !important;
    width: calc(100% + 2%) !important;
    box-shadow: $shadow-4;
  }
}
}
.contenedor-meta:hover{
   box-shadow: $shadow-4;
}
.meta {
    align-items: center;
    display: flex;
    font-weight: bold;
    margin-bottom: 10px;
    min-height: 62px;
    padding: 10px 20px;
    color: #003f87;
    letter-spacing: 0.00714em;
    font-family: DINPro;
}
</style>
